"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var interpreter_utils_1 = require("../../interpreter-utils");
var TitleModel = /** @class */ (function () {
    function TitleModel(titleMessage, titleMessageSource, customText) {
        this.titleMessage = titleMessage;
        this.titleMessageSource = titleMessageSource;
        this.customText = customText;
    }
    TitleModel.fromJSON = function (value) {
        return new TitleModel(interpreter_utils_1.getOptionalProperty(value, 'title_msg', undefined), interpreter_utils_1.getOptionalProperty(value, 'title_src', undefined), interpreter_utils_1.getOptionalProperty(value, 'custom_text', undefined));
    };
    TitleModel.prototype.toJSON = function () {
        return {
            title_msg: this.titleMessage,
            title_src: this.titleMessageSource,
            custom_text: this.customText,
        };
    };
    return TitleModel;
}());
exports.TitleModel = TitleModel;
//# sourceMappingURL=title-model.js.map